import { JSX, useContext, useEffect } from "react";
import { ColumnConfig } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { TerminationsWizardStepProps, BulkProviderTerminationMethod } from "@app/terminations/import/interfaces";
import { InvalidNpiTableData, InvalidTinTableData, ResultsSummaryTableData, ReviewProjectsTableData } from "@app/shared/provider-change-wizards/interfaces";
import { TerminationsWizardContext } from "@app/terminations/import/TerminationsWizardContext";
import PageSection from "@app/shared/PageSection";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";

const TerminationsWizardReview = (props: TerminationsWizardStepProps): JSX.Element => {
  const wizardContext = useContext(TerminationsWizardContext);

  const reviewColumnConfig: ColumnConfig = {
    details: {
      displayText: "",
      noFilter: true,
      noSort: true,
      testId: "details",
    },
    ... (wizardContext.bulkProviderTerminationMethod == BulkProviderTerminationMethod.Ghost && {
      ghostProviderCount: {
        displayText: `'${wizardContext.selectedLineOfBusiness}' Ghost Count`,
        noFilter: true,
        noSort: true,
        testId: "ghost-counts",
      },
    }),
    ...(wizardContext.bulkProviderTerminationMethod == BulkProviderTerminationMethod.Import && {
      invalidNpis: {
        displayText: `Invalid NPIs (${wizardContext.invalidNpis[0].invalidCount})`,
        noFilter: true,
        noSort: true,
        testId: "invalid-npis",
      },
      invalidTins: {
        displayText: `Invalid TINs (${wizardContext.invalidTins[0].invalidCount})`,
        noFilter: true,
        noSort: true,
        testId: "invalid-tins",
      },
    }),
    projectName: {
      displayText: `Projects (${wizardContext.reviewProjects.length})`,
      testId: "project-name",
    },
    validItems: {
      displayText: "Results Summary",
      noFilter: true,
      noSort: true,
      testId: "results-summary",
    },
  };

  useEffect(() => {
    props.formIsValid(true);
  }, []);

  return (
    <PageSection>
      <div className="container">
        {wizardContext.bulkProviderTerminationMethod == BulkProviderTerminationMethod.Import &&
          <div className="mb-2">
            <Waffles<InvalidNpiTableData>
              columns={reviewColumnConfig}
              data={wizardContext.invalidNpis}
              fullWidth={true}
              testId="import-terminations-invalid-npis"
            />
          </div>
        }
        {wizardContext.bulkProviderTerminationMethod == BulkProviderTerminationMethod.Import &&
          <RoleRestricted allowedRoles={[Roles.TIN_VIEWER]}>
            <div className="mb-2">
              <Waffles<InvalidTinTableData>
                columns={reviewColumnConfig}
                data={wizardContext.invalidTins}
                fullWidth={true}
                testId="import-terminations-invalid-tins"
              />
              </div>
          </RoleRestricted>
        }
        <div className="mb-2">
          <Waffles<ResultsSummaryTableData>
            columns={reviewColumnConfig}
            data={wizardContext.resultsSummary}
            fullWidth={true}
            testId="import-terminations-results-summary"
          />
        </div>
        <div className="mb-2">
          <Waffles<ReviewProjectsTableData>
            columns={reviewColumnConfig}
            data={wizardContext.reviewProjects}
            fullWidth={true}
            testId="import-terminations-review-projects"
          />
        </div>
      </div>
    </PageSection>
  );
};

export default TerminationsWizardReview;
